import {
  UPDATE_CLIENT_SCORING_RESULT_STATUS,
} from '../../types';

import createAsyncActions from '../../../../utilities/createAsyncActions';

export const {
  updateClientScoringResultStatus,
  updateClientScoringResultStatusPending,
  updateClientScoringResultStatusFulfilled,
  updateClientScoringResultStatusRejected,
} = createAsyncActions(UPDATE_CLIENT_SCORING_RESULT_STATUS, 'updateClientScoringResultStatus');


// WEBPACK FOOTER //
// ./src/features/client-profile/actions/postActions/updateClientScoringResultScoringStatusActions.js